<template>
  <section class="collections-container">
    <category-menu v-if="rootStore.isMobile"></category-menu>
    <section class="collection-text">
      <div class="title-holder">
        <!--  <back-button class="back-btn-comp"></back-button> -->
        <ol class="crumb-path">
          <li>
            <router-link
              class="link"
              :to="{
                name: 'printStore'
              }"
              v-if="!hideRijnjaContent"
            >
              <span>Signing</span>
              <!-- <span v-else-if="printStoreStore.categories.length > 1">{{
                printStoreTitle
              }}</span>
               --><inline-svg
                src="/images/icons/chevron-right-solid.svg"
                class="crumb-path-divider"
              ></inline-svg
            ></router-link>
          </li>
          <li>
            <h1>{{ categoryName }}</h1>
          </li>
        </ol>
        <h1 class="mob-title">{{ categoryName }}</h1>
      </div>
    </section>

    <empty-text :title="emptyTitle" :text="emptySubtitle" v-if="empty">
      <authorization-component print-store-role="ADMIN" class="buttons">
        <button class="pill-button" @click="addCollection">
          Nieuwe collectie
        </button>
        <button class="pill-button" @click="addPackage">
          Nieuw pakket
        </button>
      </authorization-component>
    </empty-text>

    <card-holder v-model="collections" v-else>
      <!--  <card-holder v-else> -->
      <template v-for="item in collections">
        <collection-card
          v-if="item.type === 'Collection'"
          :key="item.id"
          :value="item"
          @removed="removeItem(item.id)"
          @click.native="goToCollection(item.id)"
        >
        </collection-card>

        <package-card
          v-else-if="item.type === 'Package'"
          :key="item.id"
          :value="item"
          @removed="removeItem(item.id)"
        >
        </package-card>
      </template>
      <product-request v-if="!hideProductRequest"></product-request>
    </card-holder>
    <!--     </card-holder>
 -->
  </section>
</template>
<script>
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { mapStores } from 'pinia'
import PrintStoreMixin from '../PrintStoreMixin'
import {
  getCategoryContent,
  getSharedItems
} from '@/features/printstore/PrintStoreApi'
import { EventBus, Events } from '@/eventbus/EventBus'
import CollectionCard from '@/features/printstore/children/CollectionCard.vue'
import PackageCard from '@/features/printstore/children/PackageCard.vue'
import EmptyText from './EmptyText.vue'

import ProductRequest from './ProductRequest.vue'
import CategoryMenu from './CategoryMenu.vue'

export default {
  components: {
    CollectionCard,
    PackageCard,
    EmptyText,
    ProductRequest,
    CategoryMenu
  },
  mixins: [PrintStoreMixin],
  props: ['categoryId'],
  created() {
    EventBus.on(Events.CATEGORY_CONTENT_UPDATED, this.refreshDelayed)
  },
  async mounted() {
    await this.refresh()
  },
  head() {
    return {
      title:
        this.categoryName +
        ' - Signing | Koninklijke Rijnja - Prints voor professionals',
      meta: [
        {
          name: 'description',
          content: this.categoryName
        },
        {
          property: 'og:description',
          content: this.categoryName
        },
        {
          property: 'og:title',
          content:
            this.categoryName +
            ' - Signing | Koninklijke Rijnja - Prints voor professionals'
        },
        {
          property: 'og:url',
          content: this.$route.path
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Signing',
                item: 'https://www.rijnja.nl/printstore'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: this.categoryName
              }
            ]
          })
        }
      ]
    }
  },
  data() {
    return {
      emptyTitle: 'Deze categorie is nog leeg',
      collections: [],
      empty: false
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    emptySubtitle() {
      return this.rootStore.user.printStore &&
        this.rootStore.user.printStore.role
        ? 'Voeg een collectie of pakket toe'
        : ''
    },
    categoryName() {
      if (this.categoryId === 'shared') {
        return 'Aanbevolen'
      }
      let category = this.printStoreStore.getCategory(this.categoryId)
      return category ? category.name : ''
    }
  },
  methods: {
    removeItem(id) {
      const index = this.collections.findIndex((element) => element.id === id)
      this.collections.splice(index, 1)
    },
    async refresh() {
      if (this.categoryId === 'shared') {
        this.collections = await getSharedItems()
      } else {
        this.collections = await getCategoryContent(this.categoryId)

        // Hide inactive collections for non-admin users
        if (
          !this.rootStore.loggedIn ||
          this.rootStore.user.printStore.role !== 'ADMIN'
        ) {
          this.collections = this.collections.filter(
            (collection) => collection.active
          )
        }
      }
      this.empty = this.collections.length === 0
    },
    refreshDelayed() {
      setTimeout(async () => await this.refresh(), 700)
    },
    async goToCollection(id) {
      await this.$router.push({
        name: 'printStoreCollection',
        params: { categoryId: this.categoryId, collectionId: id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title-holder {
  display: flex;
  padding-left: 12px;
  padding-bottom: 8px;
  padding-top: 14px;
  align-items: flex-end;
  padding-right: 10px;
}
h1 {
  //padding-bottom: 15px;
  padding-left: 10px;
  margin-bottom: 0;
  font-size: 19px;
  font-weight: 500;
  color: var(--sub-color);
  flex-grow: 1;
  word-break: break-word;
  //line-height: 34px;
}
.buttons {
  display: block;

  button {
    margin-right: 10px;
  }
}

.package-mode {
  overflow: hidden;
}

.card-button-holder {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  .select {
    margin-left: 6px;
  }
}

.crumb-path {
  display: none;
}

.shake {
  animation: shake 1s infinite;
  cursor: grab;
}

.admin-btns {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: -6px;

  > div {
    margin: 0 5px;
    flex-shrink: 0;
  }
}

@media only screen and (min-width: 940px) {
  h1 {
    padding-left: 3px;
  }
  .back-btn-comp {
    display: none;
  }

  .mob-title {
    display: none;
  }

  .crumb-path {
    flex-grow: 1;
    display: block;
    color: var(--sub-color);
    font-weight: 400;
    line-height: 14px;
    list-style-type: none;
    display: flex;
    align-items: baseline;
    .link {
      color: var(--sub-color);
      text-decoration: none;
      display: inline-block;
    }
  }

  .divider {
    height: 10px;
    margin: 0 9px 0 6px;

    g {
      fill: var(--sub-color);
    }
  }
}
</style>
